import { ObjectField, NoPointers, PointerField, Int32Field, BooleanField, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class TempoTrack extends ObjectField {
    static create(construct) {
        return new TempoTrack(construct);
    }
    constructor(construct) {
        super(construct);
    }
    get events() {
        return this.getField(1);
    }
    get index() {
        return this.getField(10);
    }
    get minBpm() {
        return this.getField(15);
    }
    get maxBpm() {
        return this.getField(16);
    }
    get enabled() {
        return this.getField(20);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "events",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.ValueEventCollection, false),
            10: Int32Field.create({
                parent: this,
                fieldKey: 10,
                fieldName: "index",
                deprecated: false,
                pointerRules: NoPointers,
            }, "index", "", 2),
            15: Int32Field.create({
                parent: this,
                fieldKey: 15,
                fieldName: "minBpm",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 30, max: 999 }, "bpm", 60),
            16: Int32Field.create({
                parent: this,
                fieldKey: 16,
                fieldName: "maxBpm",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 31, max: 1000 }, "bpm", 240),
            20: BooleanField.create({
                parent: this,
                fieldKey: 20,
                fieldName: "enabled",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
        };
    }
}
